export default __webpack_public_path__ + "static/img-ml-vs-programming--mobile-c28284c803c03837b9ac4f18103d3efe.webp";